import { Text, TextProps, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';

export default function DateSinceDisplay({
  date,
  utc = false,
  ...textProps
}: { date: string; utc?: boolean } & TextProps) {
  const d = utc ? dayjs.utc(date) : dayjs(date);
  return (
    <Tooltip label={d.format('DD.MM.YYYY HH:mm:ss')}>
      <Text {...textProps} component="span">
        {d.fromNow()}
      </Text>
    </Tooltip>
  );
}
